export const checkIsClear = option => (option === 'clear' ? undefined : option);
